import { jsx as _jsx } from "react/jsx-runtime";
import { getMessage } from '../../messaging/MESSAGE';
import { getXOffset, getYOffset } from './blobUtils';
import { BlobContentWrapper, ForeignObject } from './Blob.styles';
export const BlobImage = ({
  messageKey,
  children,
  shouldClip = true
}) => {
  const {
    imageWidth = '100%',
    blobHeight = '100%',
    isCard = false,
    shouldUseConfigOffsetFirefox
  } = getMessage(messageKey);
  return /*#__PURE__*/_jsx(ForeignObject, {
    clipPath: shouldClip ? 'url(#innerBlob)' : '',
    height: blobHeight,
    width: imageWidth,
    x: getXOffset(messageKey, isCard),
    y: getYOffset(messageKey, isCard, shouldUseConfigOffsetFirefox),
    children: /*#__PURE__*/_jsx(BlobContentWrapper, {
      children: children
    })
  });
};